import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { ChevronRight, CreditCard } from "lucide-react";

const tabs = [
  { to: "/payments", label: "نظرة عامة", end: true },
  { to: "/payments/transactions", label: "المعاملات" },
  { to: "/payments/kashier", label: "Kashier" },
  { to: "/payments/settings", label: "الإعدادات" },
];

export default function PaymentsLayout() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 text-right" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 py-6 space-y-5">
        <div>
          <button
            type="button"
            onClick={() => navigate("/dashboard")}
            className="text-sm text-slate-500 hover:text-slate-800 flex items-center gap-1 mb-3"
          >
            <ChevronRight size={16} /> لوحة التحكم
          </button>
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-2xl bg-emerald-600 text-white">
              <CreditCard size={24} />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-slate-900">المدفوعات</h1>
              <p className="text-slate-500 text-sm">مدفوعات جراباتكم عبر Kashier. الدفع عند الاستلام لا يظهر هنا.</p>
            </div>
          </div>
        </div>
        <nav className="flex flex-wrap gap-2 bg-white rounded-2xl border border-slate-200 p-2">
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                `px-4 py-2 rounded-xl text-sm font-medium ${
                  isActive ? "bg-emerald-600 text-white" : "text-slate-600 hover:bg-slate-50"
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
        <Outlet />
      </div>
    </div>
  );
}
